import ApiCommerce from '@/core/apis/ApiCommerce';
import { IUsuario } from '@/models/Entidades/IUsuario';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { IUsuarioParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IUsuarioParametrosConsulta';
import { IDTOUsuario } from '@/models/DTO/Usuarios/IDTOUsuario';
import { IVinculo } from '@/models/Entidades/IVinculo';
/**
 * Serviço de Usuários
 */

class ServicoUsuario implements IServicoBase<IUsuario> {
  endPoint = 'usuarios';

  apiCommerce = new ApiCommerce();

  public async incluir(usuario: IUsuario): Promise<IResposta> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}`, usuario);
    return result.data;
  }

  public async atualizarVinculos(codigo: number, vinculos: IVinculo[]): Promise<IResposta> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}/${codigo}/vinculos`, vinculos);
    return result.data;
  }

  public async atualizar(usuario: IUsuario): Promise<IResposta> {
    const result: any = await this.apiCommerce.put(`${this.endPoint}/${usuario.codigo}`, usuario);
    return result.data;
  }

  public async obter(codigo: number): Promise<IUsuario> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterVinculos(codigo: number): Promise<IVinculo[]> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}/vinculos`);
    return result.data;
  }

  public async obterUsuarios(parametrosConsulta: IUsuarioParametrosConsulta): Promise<IRepostaConsulta<IDTOUsuario>> {
    let parametrosAdicionais = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametrosAdicionais += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.status !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Status=${parametrosConsulta.status}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiCommerce.get(`${this.endPoint}${parametrosAdicionais}`);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiCommerce.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async deletarVinculos(codigo: number): Promise<IResposta> {
    const result: any = await this.apiCommerce.delete(`${this.endPoint}/${codigo}/vinculos`);
    return result.data;
  }
}

export default ServicoUsuario;
